
import { Component, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-ytd-weekly-average',
  templateUrl: './ytd-weekly-average.component.html',
  styleUrls: ['./ytd-weekly-average.component.scss', '../../../dashboard.scss'],
  standalone: false
})
export class YtdWeeklyAverageComponent {

  @Input() dashboardData: any;

  ytdWeeklySalesTop: any;
  ytdWeeklySalesBottom: any;
  ytdWeeklyLabourPerTop: any;
  ytdWeeklyLabourPerBottom: any;
  ytdWeeklyTargetTop: any;
  ytdWeeklyTargetBottom: any;
  ytdWeeklyLabourHoursTop: any;
  ytdWeeklyLabourHoursBottom: any;
  ytdWeeklyOnlineSalesTop: any;
  ytdWeeklyOnlineSalesBottom: any;
  ytdWeeklyOnlineCustomerOrdersTop: any;
  ytdWeeklyOnlineCustomerOrdersBottom: any;
  ytdWeeklyDriveThruSalesTop: any;
  ytdWeeklyDriveThruSalesBottom: any;
  ytdWeeklyDriveThruOrdersTop: any;
  ytdWeeklyDriveThruOrdersBottom: any;
  ytdWeeklyCustomerOrdersTop: any;
  ytdWeeklyCustomerOrdersBottom: any;
  ytdWeeklyLabourCostTop: any;
  ytdWeeklyLabourCostBottom: any;
  ytdWeeklyItemsSoldTop: any;
  ytdWeeklyItemsSoldBottom: any;
  ytdWeeklySalesByLabourHourTop: any;
  ytdWeeklySalesByLabourHourBottom: any;
  ytdWeeklySalesValueByItemTop: any;
  ytdWeeklySalesValueByItemBottom: any;
  ytdWeeklyAverageOrderTop: any;
  ytdWeeklyAverageOrderBottom: any;


  GST_VALUE: any;
  targetImg: string = "<img class='target-arrow' src='assets/images/target_img.png' style='height:16px;vertical-align:middle;'/>";
  shopType: any;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['dashboardData']) {
      this.shopType = this.dashboardData?.sales_all_shops[0].shop_type;
      const dash_board_data = this.dashboardData?.dashboard_data_v3?.[0];
      this.GST_VALUE = dash_board_data?.gst_value ?? 1;

      // -------YTD WEEKLY AVERAGE SALES Card-------
      let ytd_weekly_sales = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.ytd_weekly_sales), 0);
      this.ytdWeeklySalesTop = ytd_weekly_sales;
      let last_year_ytd_weekly_sales = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.last_year_ytd_weekly_sales), 0);
      let ytd_weekly_sales_diff = this.setDecimalPoints(ytd_weekly_sales - last_year_ytd_weekly_sales, 0);
      let ytd_weekly_sales_per = 0;
      if (last_year_ytd_weekly_sales !== 0) {
        ytd_weekly_sales_per = this.setDecimalPoints((ytd_weekly_sales_diff / last_year_ytd_weekly_sales) * 100, 1);
      }
      let label_1_2_sales =
        '<span class="ly-row">' + this.setFontColorWithUpDownArrow(ytd_weekly_sales_per, '%', false, 1) + ' LY &nbsp; ' + '</span>' +
        '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(ytd_weekly_sales_diff, '$', false, 0) + ' LY' + '</span>';
      this.ytdWeeklySalesBottom = label_1_2_sales;

      // -------YTD WEEKLY AVERAGE LABOUR % Card-------
      let ytd_weekly_labour_cost_labour_per = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.ytd_weekly_labour_cost), 0);
      let ytd_weekly_sales_wo_gst = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.ytd_weekly_sales / this.GST_VALUE), 0);
      let ytd_weekly_labour_per = this.setDecimalPoints((ytd_weekly_labour_cost_labour_per / ytd_weekly_sales_wo_gst) * 100);
      this.ytdWeeklyLabourPerTop = ytd_weekly_labour_per + '%';
      let last_year_ytd_weekly_labour_per = this.setDecimalPoints((dash_board_data?.last_year_ytd_weekly_labour_cost / (dash_board_data?.last_year_ytd_weekly_sales / this.GST_VALUE)) * 100);
      let ytd_weekly_labour_per_diff = this.setDecimalPoints(ytd_weekly_labour_per - last_year_ytd_weekly_labour_per);
      let previous_week_no = dash_board_data?.previous_week_no ?? 1;
      let ytd_weekly_roster_labor_cost = (this.fnCheckNull(dash_board_data?.ytd_roster_labor_cost) - this.fnCheckNull(dash_board_data?.this_week_roster_labor_cost)) / previous_week_no;
      let last_week_ytd_sales_forecast = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.last_week_ytd_sales_forecast) / previous_week_no, 0);
      last_week_ytd_sales_forecast = this.setDecimalPoints(last_week_ytd_sales_forecast / this.GST_VALUE, 0);
      let ytd_weekly_roster_labor_per = this.setDecimalPoints((ytd_weekly_roster_labor_cost / last_week_ytd_sales_forecast) * 100);
      let ytd_weekly_rosted_labour_per_diff = this.setDecimalPoints(ytd_weekly_labour_per - ytd_weekly_roster_labor_per);
      let label_1_2_labour =
        '<span class="ly-row">' + this.setFontColorWithUpDownArrow(ytd_weekly_rosted_labour_per_diff, '%', true,1) + this.targetImg + ' &nbsp; ' + '</span>' +
        '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(ytd_weekly_labour_per_diff, '%', true,1) + ' LY' + '</span>';
      this.ytdWeeklyLabourPerBottom = label_1_2_labour;

      // -------YTD WEEKLY AVERAGE ONLINE SALES Card-------
      let ytd_weekly_online_sales = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.ytd_weekly_online_sales));
      this.ytdWeeklyOnlineSalesTop = ytd_weekly_online_sales;
      let ytd_weekly_online_last_year_sales = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.ytd_weekly_online_last_year_sales));
      let label_1_2_online = "- -";
      if (ytd_weekly_online_last_year_sales > 0) {
        let ytd_weekly_online_sales_diff = this.setDecimalPoints(ytd_weekly_online_sales - ytd_weekly_online_last_year_sales, 0);
        let ytd_weekly_online_sales_per = 0;
        if (ytd_weekly_online_last_year_sales !== 0) {
          ytd_weekly_online_sales_per = this.setDecimalPoints((ytd_weekly_online_sales_diff / ytd_weekly_online_last_year_sales) * 100);
        }
        label_1_2_online =
          '<span class="ly-row">' + this.setFontColorWithUpDownArrow(ytd_weekly_online_sales_per, '%', false, 1) + ' LY &nbsp; ' + '</span>' +
          '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(ytd_weekly_online_sales_diff, '$', false, 0) + ' LY' + '</span>';
      }
      this.ytdWeeklyOnlineSalesBottom = label_1_2_online;

      // -------YTD WEEKLY AVERAGE TARGET Card-------
      let ytd_weekly_target = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.ytd_weekly_target), 0);
      this.ytdWeeklyTargetTop = ytd_weekly_target;
      let last_year_ytd_weekly_target = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.last_year_ytd_weekly_target));
      let ytd_weekly_sales_total = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.ytd_weekly_sales));
      let ytd_weekly_target_diff = this.setDecimalPoints(ytd_weekly_sales_total - last_year_ytd_weekly_target, 0);
      let ytd_weekly_target_per = 0;
      if (last_year_ytd_weekly_target !== 0) {
        ytd_weekly_target_per = this.setDecimalPoints((ytd_weekly_target_diff / last_year_ytd_weekly_target) * 100);
      }
      let label_1_2_target =
        '<span class="ly-row">' + this.setFontColorWithUpDownArrow(ytd_weekly_target_per, "%", false) + this.targetImg + ' &nbsp; ' + '</span>' +
        '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(ytd_weekly_target_diff, "$", false, 0) + this.targetImg + ' &nbsp; ' + '</span>';
      this.ytdWeeklyTargetBottom = label_1_2_target;

      // -------YTD WEEKLY AVERAGE LABOUR HOURS Card-------
      let ytd_weekly_labour_hours = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.ytd_weekly_labour_hours), 0);
      this.ytdWeeklyLabourHoursTop = ytd_weekly_labour_hours;
      let last_year_ytd_weekly_labour_hours = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.last_year_ytd_weekly_labour_hours), 0);
      let ytd_weekly_labour_hours_diff = this.setDecimalPoints(ytd_weekly_labour_hours - last_year_ytd_weekly_labour_hours, 0);
      let ytd_weekly_labour_hours_per = 0;
      if (last_year_ytd_weekly_labour_hours !== 0) {
        ytd_weekly_labour_hours_per = this.setDecimalPoints((ytd_weekly_labour_hours_diff / last_year_ytd_weekly_labour_hours) * 100);
      }
      let label_1_2_labour_hours =
        '<span class="ly-row">' + this.setFontColorWithUpDownArrow(ytd_weekly_labour_hours_per, '%', true,1) + ' LY &nbsp; ' + '</span>' +
        '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(ytd_weekly_labour_hours_diff, '', true, 0) + ' LY' + '</span>';
      this.ytdWeeklyLabourHoursBottom = label_1_2_labour_hours;

      // -------YTD WEEKLY AVERAGE ONLINE CUSTOMER ORDERS Card-------
      let ytd_weekly_online_sales_count = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.ytd_weekly_online_sales_count), 0);
      this.ytdWeeklyOnlineCustomerOrdersTop = ytd_weekly_online_sales_count;
      let last_year_ytd_weekly_online_sales_count = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.last_year_ytd_weekly_online_sales_count), 0);
      let label_1_2_online_orders = "- -";
      if (last_year_ytd_weekly_online_sales_count > 0) {
        let ytd_weekly_online_sales_count_diff = this.setDecimalPoints(ytd_weekly_online_sales_count - last_year_ytd_weekly_online_sales_count, 0);
        let ytd_weekly_online_sales_count_per = 0;
        if (last_year_ytd_weekly_online_sales_count !== 0) {
          ytd_weekly_online_sales_count_per = this.setDecimalPoints((ytd_weekly_online_sales_count_diff / last_year_ytd_weekly_online_sales_count) * 100);
        }
        label_1_2_online_orders =
          '<span class="ly-row">' + this.setFontColorWithUpDownArrow(ytd_weekly_online_sales_count_per, '%', false, 1) + ' LY &nbsp; ' + '</span>' +
          '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(ytd_weekly_online_sales_count_diff, '', false, 0) + ' LY' + '</span>';
      }
      this.ytdWeeklyOnlineCustomerOrdersBottom = label_1_2_online_orders;

      // -------YTD WEEKLY AVERAGE DRIVE-THRU SALES Card-------
      let ytd_weekly_dt_sales = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.ytd_weekly_dt_sales));
      this.ytdWeeklyDriveThruSalesTop = ytd_weekly_dt_sales;
      let last_year_ytd_weekly_dt_sales = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.last_year_ytd_weekly_dt_sales));
      let label_1_2_dt_sales = "--";
      if (last_year_ytd_weekly_dt_sales > 0) {
        let ytd_weekly_dt_sales_diff = this.setDecimalPoints(ytd_weekly_dt_sales - last_year_ytd_weekly_dt_sales, 0);
        let ytd_weekly_dt_sales_per = 0;
        if (last_year_ytd_weekly_dt_sales !== 0) {
          ytd_weekly_dt_sales_per = this.setDecimalPoints((ytd_weekly_dt_sales_diff / last_year_ytd_weekly_dt_sales) * 100);
        }
        label_1_2_dt_sales =
          '<span class="ly-row">' + this.setFontColorWithUpDownArrow(ytd_weekly_dt_sales_per, '%', false, 1) + ' LY &nbsp; ' + '</span>' +
          '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(ytd_weekly_dt_sales_diff, '$', false, 0) + ' LY' + '</span>';
      }
      this.ytdWeeklyDriveThruSalesBottom = label_1_2_dt_sales;

      // -------YTD WEEKLY AVERAGE DRIVE-THRU ORDERS Card-------
      let ytd_weekly_dt_sales_count = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.ytd_weekly_dt_sales_count), 0);
      this.ytdWeeklyDriveThruOrdersTop = ytd_weekly_dt_sales_count;
      let last_year_ytd_weekly_dt_sales_count = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.last_year_ytd_weekly_dt_sales_count), 0);
      let label_1_2_dt_orders = "--";
      if (last_year_ytd_weekly_dt_sales_count > 0) {
        let ytd_weekly_dt_sales_count_diff = this.setDecimalPoints(ytd_weekly_dt_sales_count - last_year_ytd_weekly_dt_sales_count, 0);
        let ytd_weekly_dt_sales_count_per = 0;
        if (last_year_ytd_weekly_dt_sales_count !== 0) {
          ytd_weekly_dt_sales_count_per = this.setDecimalPoints((ytd_weekly_dt_sales_count_diff / last_year_ytd_weekly_dt_sales_count) * 100);
        }
        label_1_2_dt_orders =
          '<span class="ly-row">' + this.setFontColorWithUpDownArrow(ytd_weekly_dt_sales_count_per, '%', false, 1) + ' LY &nbsp; ' + '</span>' +
          '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(ytd_weekly_dt_sales_count_diff, '', false, 0) + ' LY' + '</span>';
      }
      this.ytdWeeklyDriveThruOrdersBottom = label_1_2_dt_orders;

      // -------YTD WEEKLY AVERAGE CUSTOMER ORDERS Card-------
      let ytd_weekly_no_of_cust_orders = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.ytd_weekly_no_of_cust_orders), 0);
      this.ytdWeeklyCustomerOrdersTop = ytd_weekly_no_of_cust_orders;
      let ytd_last_year_weekly_no_of_cust_orders = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.ytd_last_year_weekly_no_of_cust_orders), 0);
      let ytd_weekly_no_of_cust_orders_diff = this.setDecimalPoints(ytd_weekly_no_of_cust_orders - ytd_last_year_weekly_no_of_cust_orders, 0);
      let ytd_weekly_no_of_cust_orders_per = 0;
      if (ytd_last_year_weekly_no_of_cust_orders !== 0) {
        ytd_weekly_no_of_cust_orders_per = this.setDecimalPoints((ytd_weekly_no_of_cust_orders_diff / ytd_last_year_weekly_no_of_cust_orders) * 100, 0);
      }
      let label_1_2_cust_orders =
        '<span class="ly-row">' + this.setFontColorWithUpDownArrow(ytd_weekly_no_of_cust_orders_per, '%', false,1) + ' LY &nbsp; ' + '</span>' +
        '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(ytd_weekly_no_of_cust_orders_diff, '', false, 0) + ' LY' + '</span>';
      this.ytdWeeklyCustomerOrdersBottom = label_1_2_cust_orders;

      // -------YTD WEEKLY AVERAGE LABOUR COST Card-------
      let ytd_weekly_labour_cost_labour_cost = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.ytd_weekly_labour_cost), 0);
      this.ytdWeeklyLabourCostTop = ytd_weekly_labour_cost_labour_cost;
      let last_year_ytd_weekly_labour_cost = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.last_year_ytd_weekly_labour_cost), 0);
      let ytd_weekly_labour_cost_diff = this.setDecimalPoints(ytd_weekly_labour_cost_labour_cost - last_year_ytd_weekly_labour_cost, 0);
      let ytd_weekly_labour_cost_per = 0;
      if (last_year_ytd_weekly_labour_cost !== 0) {
        ytd_weekly_labour_cost_per = this.setDecimalPoints((ytd_weekly_labour_cost_diff / last_year_ytd_weekly_labour_cost) * 100, 0);
      }
      let label_1_2_labour_cost =
        '<span class="ly-row">' + this.setFontColorWithUpDownArrow(ytd_weekly_labour_cost_per, '%', true,1) + ' LY &nbsp; ' + '</span>' +
        '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(ytd_weekly_labour_cost_diff, '$', true, 0) + ' LY' + '</span>';
      this.ytdWeeklyLabourCostBottom = label_1_2_labour_cost;

      // -------YTD WEEKLY AVERAGE ITEM SOLD Card-------
      let ytd_weekly_items_sold = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.ytd_weekly_items_sold), 0);
      this.ytdWeeklyItemsSoldTop = ytd_weekly_items_sold;
      let last_year_ytd_weekly_items_sold = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.last_year_ytd_weekly_items_sold), 0);
      let ytd_weekly_items_sold_diff = this.setDecimalPoints(ytd_weekly_items_sold - last_year_ytd_weekly_items_sold, 0);
      let ytd_weekly_items_sold_per = 0;
      if (last_year_ytd_weekly_items_sold !== 0) {
        ytd_weekly_items_sold_per = this.setDecimalPoints((ytd_weekly_items_sold_diff / last_year_ytd_weekly_items_sold) * 100, 0);
      }
      let label_1_2_items_sold =
        '<span class="ly-row">' + this.setFontColorWithUpDownArrow(ytd_weekly_items_sold_per, '%', false,1) + ' LY &nbsp; ' + '</span>' +
        '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(ytd_weekly_items_sold_diff, '', false, 0) + ' LY' + '</span>';
      this.ytdWeeklyItemsSoldBottom = label_1_2_items_sold;

      // -------YTD WEEKLY AVERAGE SALES / LABOUR HOUR Card-------
      let ytd_weekly_sales_by_labour_hour = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.ytd_weekly_sales / dash_board_data?.ytd_weekly_labour_hours), 2);
      this.ytdWeeklySalesByLabourHourTop = ytd_weekly_sales_by_labour_hour;
      let ytd_weekly_sales_by_labour_lastyear = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.last_year_ytd_weekly_sales / dash_board_data?.last_year_ytd_weekly_labour_hours), 2);
      let ytd_weekly_sales_by_labour_ly1 = this.setDecimalPoints(this.fnCheckNull(ytd_weekly_sales_by_labour_hour - ytd_weekly_sales_by_labour_lastyear));
      let ytd_weekly_sales_by_labour_ly2 = 0;
      if (ytd_weekly_sales_by_labour_lastyear !== 0) {
        ytd_weekly_sales_by_labour_ly2 = this.setDecimalPoints(this.fnCheckNull((ytd_weekly_sales_by_labour_ly1 / ytd_weekly_sales_by_labour_lastyear) * 100));
      }
      let label_1_2_sales_by_labour =
        '<span class="ly-row">' + this.setFontColorWithUpDownArrow(ytd_weekly_sales_by_labour_ly2, "%", false,1) + ' LY &nbsp; ' + '</span>' +
        '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(ytd_weekly_sales_by_labour_ly1, "$", false, 0) + ' LY' + '</span>';
      this.ytdWeeklySalesByLabourHourBottom = label_1_2_sales_by_labour;

      // -------YTD WEEKLY AVERAGE SALES VALUE / ITEM Card-------
      let ytd_weekly_sales_value_by_item = 0;
      if (ytd_weekly_sales && ytd_weekly_items_sold) {
        ytd_weekly_sales_value_by_item = this.setDecimalPoints(ytd_weekly_sales / ytd_weekly_items_sold, 2);
      }
      // console.log(ytd_weekly_items_sold)
      this.ytdWeeklySalesValueByItemTop = ytd_weekly_sales_value_by_item;
      let last_year_ytd_weekly_sales_value_by_item = 0;
      if (last_year_ytd_weekly_sales && last_year_ytd_weekly_items_sold) {
        last_year_ytd_weekly_sales_value_by_item = this.setDecimalPoints(last_year_ytd_weekly_sales / last_year_ytd_weekly_items_sold, 2);
      }
      let ytd_weekly_sales_value_by_item_diff = this.setDecimalPoints(ytd_weekly_sales_value_by_item - last_year_ytd_weekly_sales_value_by_item, 2);
      let ytd_weekly_sales_value_by_item_per = 0;
      if (last_year_ytd_weekly_sales_value_by_item !== 0) {
        ytd_weekly_sales_value_by_item_per = this.setDecimalPoints((ytd_weekly_sales_value_by_item_diff / last_year_ytd_weekly_sales_value_by_item) * 100, 1);
      }
      let label_1_2_sales_value_by_item =
        '<span class="ly-row">' + this.setFontColorWithUpDownArrow(ytd_weekly_sales_value_by_item_per, '%', false,1) + ' LY &nbsp; ' + '</span>' +
        '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(ytd_weekly_sales_value_by_item_diff, '$', false, 2) + ' LY' + '</span>';
      this.ytdWeeklySalesValueByItemBottom = label_1_2_sales_value_by_item;

      // -------YTD WEEKLY AVERAGE AVERAGE ORDER $ Card-------
      let ytd_weekly_average_order = 0;
      if (ytd_weekly_sales && ytd_weekly_no_of_cust_orders) {
        ytd_weekly_average_order = this.setDecimalPoints(ytd_weekly_sales / ytd_weekly_no_of_cust_orders, 2);
      }
      this.ytdWeeklyAverageOrderTop = ytd_weekly_average_order;
      let last_year_ytd_weekly_average_order = 0;
      if (last_year_ytd_weekly_sales && ytd_last_year_weekly_no_of_cust_orders) {
        last_year_ytd_weekly_average_order = this.setDecimalPoints(last_year_ytd_weekly_sales / ytd_last_year_weekly_no_of_cust_orders, 2);
      }
      let ytd_weekly_average_order_diff = this.setDecimalPoints(ytd_weekly_average_order - last_year_ytd_weekly_average_order, 0);
      let ytd_weekly_average_order_per = 0;
      if (last_year_ytd_weekly_average_order !== 0) {
        ytd_weekly_average_order_per = this.setDecimalPoints((ytd_weekly_average_order_diff / last_year_ytd_weekly_average_order) * 100, 1);
      }
      let label_1_2_average_order =
        '<span class="ly-row">' + this.setFontColorWithUpDownArrow(ytd_weekly_average_order_per, "%", false,1) + ' LY &nbsp; ' + '</span>' +
        '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(ytd_weekly_average_order_diff, "$", false, 0) + ' LY' + '</span>';
      this.ytdWeeklyAverageOrderBottom = label_1_2_average_order;
    }
  }

  setFontColorWithUpDownArrow(
    numberForSet: number,
    symbol: string = '',
    reverse: boolean = false,
    decimal: number = 1
  ): string {
    if (isNaN(numberForSet)) {
            return '-- ';
        }
    let baseNumber: string | number = numberForSet;
    let numberWithSymbol: string;

    if (symbol === '%') {
      baseNumber = Number(numberForSet).toLocaleString('en-US', {
        style: 'decimal',
        useGrouping: true,
        minimumFractionDigits: decimal,
        maximumFractionDigits: decimal,
      });
      numberWithSymbol = baseNumber + symbol;
    } else if (symbol === '$') {
      baseNumber = Number(numberForSet).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: decimal,
      });
      numberWithSymbol = baseNumber as string;
    } else {
      numberWithSymbol = Number(numberForSet).toLocaleString('en-US', {
        style: 'decimal',
        useGrouping: true,
        minimumFractionDigits: decimal,
      });
    }

    let arrow = '';
    if (Math.sign(numberForSet) === 1) {
      arrow = '▲';
    } else if (Math.sign(numberForSet) === -1) {
      arrow = '▼';
    }

    const compareValue = reverse ? numberForSet * -1 : numberForSet;

    if (Math.sign(compareValue) === 0) {
      return numberWithSymbol;
    } else if (Math.sign(compareValue) === 1) {
      let colorWithNumber = `<span class='cgreen'>${numberWithSymbol}${arrow}</span>`;
      colorWithNumber = colorWithNumber.replace('-', '');
      return colorWithNumber;
    } else if (Math.sign(compareValue) === -1) {
      let colorWithNumber = `<span class='cred'>${numberWithSymbol}${arrow}</span>`;
      colorWithNumber = colorWithNumber.replace('-', '');
      return colorWithNumber;
    } else {
      return numberWithSymbol;
    }
  }

  setDecimalPoints(value: number, decimal: number = 1): number {
    return Number(Number(value).toFixed(decimal));
  }

  fnCheckNull(a: any): number {
    return a == null ? 0 : a;
  }

}
